import React from 'react';
import * as FaIcons from 'react-icons/fa';
import SafeIcon from '../common/SafeIcon';

const {FaApple}=FaIcons;
const buttonSize='h-[78px] w-[250px] sm:w-[270px]';

export const AppStoreButton=()=> (
  <a
    href="https://apps.apple.com/us/app/wingcue-your-ai-wingman/id6806146653"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Download Wingcue on the Apple App Store"
    className={`group flex ${buttonSize} items-center justify-center gap-4 rounded-2xl bg-white px-9 text-black shadow-[0_4px_24px_rgba(255,255,255,0.12)] transition-all duration-300 hover:scale-[1.02] hover:bg-gray-100 active:scale-[0.98]`}
  >
    <SafeIcon icon={FaApple} className="flex-shrink-0 text-[36px]" />
    <div className="flex flex-col items-start leading-none">
      <span className="mb-1 text-[10px] font-semibold uppercase tracking-widest text-black/50">
        Download on the
      </span>
      <span className="text-[21px] font-bold tracking-tight">App Store</span>
    </div>
  </a>
);

export const PlayStoreButton=()=> (
  <a
    href="https://play.google.com/store/apps/details?id=com.rork.wingcue&pli=1"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Get Wingcue on Google Play"
    className={`group flex ${buttonSize} items-center justify-center overflow-hidden rounded-2xl border border-white/25 bg-black p-1 transition-all duration-300 hover:scale-[1.02] hover:border-white/45 active:scale-[0.98]`}
  >
    <img
      src="https://global.divhunt.com/2af1aa34d0e9e3ecc86ecb561fe66838_9163.avif"
      alt="Get it on Google Play"
      className="h-full w-full rounded-xl object-fill"
    />
  </a>
);